/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { RestService } from './rest.service';
import {
  LoginRequest,
  AuthenticationService,
  MobileRequest,
} from '@ews/users-management';
import { StorageService } from './storage.service';
import { StateService } from './state.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  public token: string | null;
  public username: any;
  public userId: any;
  public loginError = '';

  constructor(
    private http: HttpClient,
    private rest: RestService,
    private auth: AuthenticationService,
    private router: Router,
    private storage: StorageService,
    private stateService: StateService
  ) {}

  public loginNew(
    rememberMe: boolean,
    username: string,
    password: string
  ): Observable<boolean> {
    return new Observable<boolean>((subscriber) => {
      const form = new LoginRequest(username, password, rememberMe);
      this.auth.login(form).subscribe({
        next: (response) => {
          console.log('Response loginNew => ', response);
          subscriber.next(true);
        },
        error: (error) => {
          console.log('Error loginNew => ', error);
          subscriber.error(error);
        },
        complete: () => {
          subscriber.complete();
        },
      });
    });
  }

  public loginNewMobile(mobileId: string): Observable<boolean> {
    return new Observable<boolean>((subscriber) => {
      const mobileRequest = new MobileRequest(mobileId);
      this.auth.mobileLogin(mobileRequest).subscribe({
        next: (response) => {
          console.log('Response loginNewMobile => ', response);
          subscriber.next(true);
        },
        error: (error) => {
          console.log('Error loginNewMobile => ', error);
          subscriber.error(error);
        },
        complete: () => {
          subscriber.complete();
        },
      });
    });
  }

  public addMobileId(mobileId: string): Observable<boolean> {
    return new Observable<boolean>((subscriber) => {
      const headers = new HttpHeaders({});

      const options = {
        headers,
      };
      this.http
        .post(
          this.rest.baseUrl + 'v2/authentication/addmobileid',
          {
            mobileId,
          },
          options
        )
        .subscribe({
          next: (response) => {
            console.log('Response addMobileId => ', response);
            subscriber.next(true);
          },
          error: (error) => {
            console.log('Error addMobileId => ', error);
            subscriber.error(error);
          },
          complete: () => {
            subscriber.complete();
          },
        });
    });
  }

  public removeMobileId(mobileId: string): Observable<boolean> {
    return new Observable<boolean>((subscriber) => {
      const headers = new HttpHeaders({});

      const options = {
        headers,
      };
      this.http
        .post(
          this.rest.baseUrl + 'v2/authentication/removeMobileid',
          {
            mobileId,
          },
          options
        )
        .subscribe({
          next: (response) => {
            console.log('Response removeMobileId => ', response);
            subscriber.next(true);
          },
          error: (error) => {
            console.log('Error removeMobileId => ', error);
            subscriber.error(error);
          },
          complete: () => {
            subscriber.complete();
          },
        });
    });
  }

  public async logoutNew() {
    this.storage.get('hashcode').then((val) => {
      if (val) {
        this.removeMobileId(val).subscribe({
          next: (resultRemove) => {
            this.performLogout();
          },
          error: () => {
            this.performLogout();
          },
        });
      } else {
        this.performLogout();
      }
    });
  }

  public logout(): void {
    this.token = null;
    this.username = null;
    this.rest.username = null;
    this.userId = null;
    this.clearState();
  }

  private performLogout(): void {
    this.storage.removeStorageItem('hashcode');
    this.auth.logout().subscribe((result) => {
      console.log('logged out');
      this.logout();
      this.router.navigate(['login']);
    });
  }

  private clearState(): void {
    // Clear all state when logging out
    // Add any state cleanup as needed in the future
  }
}

export interface ValidationResult {
  [key: string]: boolean;
}
